import React from 'react';
import { useConfig } from '../../../../hooks/useConfig';
import type { OrganizationDetail } from '../../../../api';
import OrganizationDiagram from './OrganizationDiagram';
import OrganizationDiagram3D from './OrganizationDiagram3D';
import { normalizeScenarioTaskDiagramRenderMode } from './renderMode';
import type { OrganizationRuntimeState } from './types';
import type { OrganizationGraphCompileResult } from './utils/organizationGraph';

interface OrganizationDiagramRendererProps {
  detail: OrganizationDetail | null;
  orgStates: Map<string, OrganizationRuntimeState>;
  suppressMotion?: boolean;
  onCompiled?: (graph: OrganizationGraphCompileResult) => void;
  mode?: 'runtime' | 'management';
}

const OrganizationDiagramRenderer: React.FC<OrganizationDiagramRendererProps> = props => {
  const { globalConfig } = useConfig();
  const config = globalConfig as {
    scenarioTaskOrganizationDiagramRenderMode?: unknown;
  };
  const renderMode = normalizeScenarioTaskDiagramRenderMode(
    config.scenarioTaskOrganizationDiagramRenderMode
  );

  if (renderMode === '3d') {
    return <OrganizationDiagram3D {...props} />;
  }

  return <OrganizationDiagram {...props} />;
};

export default OrganizationDiagramRenderer;
